import clsx from 'clsx'
import update from 'immutability-helper'
import React, { useState, useEffect } from 'react'
import Select from 'react-select'

const types = {checkbox: Checkbox, textarea: Textarea, panel: Panel, dropdown: Dropdown, radiopanel: RadioPanel}

function getValue (context, field, contentId, panelId, contentIndex) {

  const data = context.newPlan
  if (!data.items) return 

  const item = data.items.find(i => i.id === field)
  if (!item) return

  const insidePanel = panelId !== undefined
  const insideList = contentIndex !== undefined

  const {content} = item
  const section = content.sections[insidePanel ? panelId : contentId]
  if (!section) return
  if (insidePanel) {
    const child = section.children[contentId]
    if (!child) return
    return insideList
      ? child.value[contentIndex]
      : child.value
  } else {
    return insideList
      ? section.value[contentIndex]
      : section.value
  }
}

function setValue (context, field, contentId, value, panelId, contentIndex) {
  const data = context.newPlan
  const insidePanel = panelId !== undefined
  const insideList = contentIndex !== undefined
  if (data.items) {
    const items = data.items.map(item => {
      if (item.id != field) return item
      const {content} = item
      const sections = content.sections.map((section, index) => {
        if (insidePanel){
          if (index !== panelId) {
            return section
          } else {
            const children = section.children.map((child, index) => {
              if (index !== contentId) return child
              if (!insideList) return {...child, value}
              return {
                ...child,
                value: child.value.map((v,index) => index === contentIndex ? value : v)
              }
            })
            return {...section, children}
          }
        } else {
          if (index !== contentId) {
            return section
          } else {
            if (!insideList) {
              return {...section, value}
            } else {
              return {
                ...section,
                value: section.value.map((v,index) => index === contentIndex ? value : v)
              }
            }
          }
        }
      })
      return {...item, content: {...content, sections}}
    })
    const newPlan = {...data, items}
    context.setState({newPlan})
  }
}


function Dropdown (props) {
  const {name, count, grouped, value, optionsMap, mapIndex, context} = props

  const [optionsSelector] = getValue(props.context, props.id, mapIndex, props.panelId) || []

  function updateDropdownProperties (propertyUpdates) {
    const insidePanel = props.panelId !== undefined
    const itemIndex = props.context.newPlan.items.findIndex(i => i.id === props.id)
    if (itemIndex >= 0) {
      const updateCommand = insidePanel
          ? {newPlan: {items: {[itemIndex]: {content: {sections: {[props.panelId]: {children: {[props.contentId]: propertyUpdates}}}}}}}}
          : {newPlan: {items: {[itemIndex]: {content: {sections: {[props.contentId]: propertyUpdates}}}}}}
      context.updateState(updateCommand)
    }
  }

  React.useEffect(() => {
    if (optionsMap) {
      const options = optionsMap[optionsSelector] || []
      const value = (props.optionsSelector === optionsSelector && props.value) || ""
      updateDropdownProperties(
        {value: {$set: [value]}, options: {$set: options}, optionsSelector: {$set: optionsSelector}}
      )
    }
  }, [optionsSelector])

  const selects = value.map((val, index) => { 
    const label = value.length < 2 ? name : `${name} ${index + 1}`
    return (
      <div key={index} className="select">
        {!grouped && name && (<label>{label}</label>)}
        <Select
          isClearable={true}
          isSearchable = {true}
          placeholder={context.translate('pick_one')}
          value={{label: val, value: val}}
          onChange = {option => {
            const {value} = option || {}
            if (optionsMap) {
              updateDropdownProperties({optionsSelector: {$set: optionsSelector}})
            }
            setValue(props.context, props.id, props.contentId, value, props.panelId, index)
          }}
          options = {props.options.map(a => ({label: a, value: a}))}
        />
      </div>)
 })
  return (
    <div>
      {grouped && (<label>{name}</label>)}
      {selects}
    </div>
  )
}

function Checkbox (props) {
  const {context} = props
  return (
    <div>
      <label>
        <input
          type="checkbox"
          checked={props.value}
          onChange={event => {
            setValue(context, props.id, props.contentId, event.target.checked, props.panelId)
          }}
        />
        {props.name}
      </label>
    </div>
  )
}


function Textarea ({context, name, maxlength, value, id, panelId, contentId}) {

  const [text, setText] = useState('');
  
  const handleChange = ({target}) => {
    setText(target.value);
    setTimeout(() => {
      if(target.value !== value ){
        console.log(target.value)
        setValue(context, id, contentId, target.value, panelId);
      }
    }, 2000)
  };

  useEffect(() => {
    if(text != value) {
      setText(value)
    }
  }, [value])

  return (
    <div>
      <label>{name}</label>
      <textarea
        placeholder={context.translate('write_here')}
        value={text}
        rows={4}
        onChange={handleChange}
      />
    </div>
  )
}

function Panel (panelProps) {
  const {id, name, context} = panelProps
  const children = panelProps.children
    .map((props, contentId) => ({props, Element: types[props.type], contentId}))
    .filter(section => section.Element)
    .map(({Element, props, contentId}, index) => (
      <Element
        key={index}
        id={id}
        panelId={panelProps.contentId}
        contentId={contentId}
        context={context}
        {...props}
      />))

  return (
    <div>
      <label>{name}</label>
      <div className="children">
        {children}
      </div>
    </div>
  )
}

function RadioPanel (panelProps) {
  const {id, name, context} = panelProps
  const children = panelProps.children
    .map((props, contentId) => {

      const radioId = `${id}-radio-${contentId}`
      const checked = panelProps.value === props.name
      const children = checked && props.value
        .map((props, index) => {
          return (
            <div key={index} className={clsx("radio-panel-option", {checked})}>
              <label>
                <input
                  type="checkbox"
                  checked={props.value || false}
                  onChange={event => {
                    setValue(context, id, contentId, update(props, {value: {$set: event.target.checked}}), panelProps.contentId, index)
                  }}
                />
                {props.name}
              </label>
            </div>
          )
      })

      return (
        <div className={clsx("radio-panel-item", {checked})} key={contentId}>
          <input
            id={radioId}
            type="radio"
            name={id}
            checked={checked}
            value={props.name}
            onChange={event => {
              setValue(context, panelProps.id, panelProps.contentId, event.target.value, panelProps.panelId)
            }}
          />
          <label htmlFor={radioId}>{props.name}</label>
          {children && children.length > 0 && (
            <div className="children">
              {children}
            </div>
          )}
        </div>
      )
    })
  return (
    <div>
      <label>{name}</label>
      <div className="children">
        {children}
      </div>
    </div>
  )
}

export default types
